import { Howl } from 'howler'
import { config } from 'settings/custom/audiosprite'
import { delay } from 'utils/Delay'
import { log } from 'utils/Logger'

export default class SoundGUI {
  constructor() {
    this.global = { 'Enable Editor': false, 'Export to Console': () => {} }
    this.howl = null
    this.list = {}
    this.controllers = null
    this.folders = null

    Object.keys(config.sprite).forEach((name) => this.list[name] = { volume: 1, fadeIn: 0, fadeOut: 0, playing: false, Play: () => {}, Stop: () => {} })
  }

  init(){
    this.folders =  game.gui.folders
    this.controllers =  game.gui.controllers

    this.folders.sound = game.gui.addFolder('Sound')
    this.controllers.sound =  this.folders.sound.add(this.global, 'Enable Editor')
    this.controllers.sound.onChange(this.onEnable.bind(this))
    this.howl = new Howl(config)
    this.howl.on('end', this.onEnd.bind(this))
    this.createEditor()
  }

  onEnable(value){
    game.managers.SoundManager.core.setEdit(value)
    this.stopAll()
  }

  createEditor(){
    this.controllers.sound.toConsole = this.folders.sound.add(this.global, 'Export to Console')
    this.controllers.sound.toConsole.onChange(this._toConsole.bind(this))

    Object.keys(this.list).forEach((key) => {
      this.folders.sound[key] = this.folders.sound.addFolder(key)
      this.controllers.sound[key] = {}

      this.controllers.sound[key].volume = this.folders.sound[key].add(this.list[key], 'volume', 0, 1)
      this.controllers.sound[key].fadeIn = this.folders.sound[key].add(this.list[key], 'fadeIn', 0, 5000)
      this.controllers.sound[key].fadeOut = this.folders.sound[key].add(this.list[key], 'fadeOut', 0, 5000)
      this.controllers.sound[key].play = this.folders.sound[key].add(this.list[key], 'Play')
      this.controllers.sound[key].stop = this.folders.sound[key].add(this.list[key], 'Stop')

      this.controllers.sound[key].volume.onChange(() => this.volume.call(this, key))
      this.controllers.sound[key].play.onChange(() => this.play.call(this, key))
      this.controllers.sound[key].stop.onChange(() => this.stop.call(this, key))
    })
  }

  play(key){
    if (this.global['Enable Editor'] && !this.list[key].playing){
      const id = this.howl.play(key)
      this.list[key].id = id
      this.list[id] = key
      this.list[key].playing = true

      this.howl.fade(0, this.list[key].volume, this.list[key].fadeIn, id)
    }
  }

  stop(key){
    if (this.global['Enable Editor']) {
      const sound = this.list[key]
      this.howl.fade(sound.volume, 0, sound.fadeOut, sound.id)
      delay(sound.fadeOut / 1000).then(() => {
        sound.playing = false
        this.howl.stop(sound.id)
      })
    }
  }

  stopAll(){
    Object.keys(this.list).forEach((key) => {
      if(this.list[key].playing){
        this.howl.stop(this.list[key].id)
        this.list[key].playing = false
      }
    })
  }

  volume(key){
    if (this.global['Enable Editor']) {
      const sound = this.list[key]
      this.howl.volume(sound.volume, sound.id)
    }
  }

  onEnd(id){
    this.list[this.list[id]].playing = false
  }

  _toConsole(){
    const res = Object.keys(this.list)
      .filter((val) => isNaN(val))
      .map((key) => {
        return {
          sound: key,
          volume: this.list[key].volume,
          fadeIn: this.list[key].fadeIn,
          fadeOut: this.list[key].fadeOut,
        }
      })
    log(res)
  }
}
